/* HALAL ICHIBA renewal — shop behaviours
   - Add to cart without leaving the page ([data-rnw-add] forms) + toast + header/free-shipping refresh
   - Favorites (wishlist) kept in this browser ([data-wish] toggles, [data-wish-open] drawer)
   - Predictive search under the header search boxes ([data-psearch])
   - Matching pages/articles on the search results page ([data-search-extra])
   - Copy-link button ([data-copy-url])
   Settings and translated strings come from window.RNW (renewal-header section). */
(function () {
  'use strict';

  var C = window.RNW || {};
  var T = C.t || {};
  var root = (C.root || '/').replace(/\/?$/, '/'); // '/' or '/en/'
  var JSON_HEADERS = { 'Accept': 'application/json' };

  // ---------- helpers ----------
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function money(cents) {
    var n = Number(cents) || 0;
    function num(decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return (C.moneyFormat || '¥{{amount_no_decimals}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return num(2, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        default: return num(0, ',', '.');
      }
    });
  }
  function getJSON(url) {
    return fetch(url, { headers: JSON_HEADERS, credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) { var err = new Error(r.status); err.status = r.status; throw err; }
      return r.json();
    });
  }

  // ---------- toast ----------
  var toastEl, toastTimer;
  function toast(html, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rnw-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.toggle('is-error', !!isError);
    // restart the enter animation
    toastEl.classList.remove('is-show');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, isError ? 7000 : 5000);
  }
  function hideToast() { if (toastEl) toastEl.classList.remove('is-show'); }
  function closeBtn() {
    return '<button type="button" class="rnw-toast__close" data-toast-close aria-label="' + esc(T.close) + '">×</button>';
  }

  // ---------- cart ----------
  function updateFreeship(box, totalCents) {
    var th = parseInt(box.getAttribute('data-freeship'), 10) || 0;
    if (!th) return;
    var total = Math.floor(totalCents / 100);
    var remaining = th - total;
    var msg = box.querySelector('[data-fs-msg]');
    var sub = box.querySelector('[data-fs-sub]');
    var bar = box.querySelector('[data-fs-bar]');
    if (msg && T.fsRemaining) msg.textContent = remaining > 0 ? T.fsRemaining.replace('[amount]', money(remaining * 100)) : T.fsApplied;
    if (sub && T.fsCart) sub.textContent = T.fsCart.replace('[total]', money(totalCents)).replace('[threshold]', money(th * 100));
    if (bar) bar.style.width = Math.min(100, Math.floor(total * 100 / th)) + '%';
  }
  function updateCartUI(cart) {
    if (!cart) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = !cart.item_count;
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
    document.querySelectorAll('[data-freeship]').forEach(function (box) { updateFreeship(box, cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price); });
  }
  function refreshCart() {
    return getJSON(root + 'cart.js').then(function (cart) { updateCartUI(cart); return cart; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-rnw-add]');
    if (!form || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var buttons = [].slice.call(document.querySelectorAll('button[type="submit"]')).filter(function (b) {
      return b.form === form && !b.disabled;
    });
    buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });

    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw body;
          return body.items ? body.items[0] : body;
        });
      })
      .then(function (item) {
        return refreshCart().catch(function () {}).then(function () {
          var img = item && (item.featured_image && item.featured_image.url || item.image);
          toast(
            '<div class="rnw-toast__row">' +
              (img ? '<img src="' + esc(sized(img, 120)) + '" alt="" width="48" height="48">' : '') +
              '<div class="rnw-toast__text"><b>' + esc(T.added) + '</b><span>' + esc(item ? (item.product_title || item.title) : '') + '</span></div>' +
              closeBtn() +
            '</div>' +
            '<a class="btn btn--primary rnw-toast__cta" href="' + esc(C.cartUrl || root + 'cart') + '">' + esc(T.viewCart) + '</a>'
          );
        });
      })
      .catch(function (err) {
        var detail = err && typeof err.description === 'string' ? err.description : '';
        toast(
          '<div class="rnw-toast__row"><div class="rnw-toast__text"><b>' + esc(T.addError) + '</b>' +
          (detail ? '<span>' + esc(detail) + '</span>' : '') + '</div>' + closeBtn() + '</div>',
          true
        );
      })
      .then(function () {
        buttons.forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
      });
  });

  // Back/forward cache can restore a stale header: refresh counts.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { refreshCart().catch(function () {}); wlSync(); }
  });

  // ---------- favorites (wishlist) ----------
  var WKEY = 'hi-wishlist';
  var WMAX = 100;
  function wlGet() {
    try {
      var a = JSON.parse(localStorage.getItem(WKEY) || '[]');
      return Array.isArray(a) ? a.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (err) { return []; }
  }
  function wlSet(a) {
    try { localStorage.setItem(WKEY, JSON.stringify(a.slice(0, WMAX))); } catch (err) {}
    wlSync();
  }
  function wlToggle(handle) {
    var a = wlGet();
    var i = a.indexOf(handle);
    if (i > -1) { a.splice(i, 1); } else { a.unshift(handle); }
    wlSet(a);
  }
  function wlSync() {
    var a = wlGet();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? T.wishRemove : T.wishAdd);
      b.title = on ? T.wishRemove : T.wishAdd;
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.textContent = a.length;
      el.hidden = !a.length;
    });
    if (document.body.classList.contains('wish-open')) wlRender();
  }

  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = getJSON(root + 'products/' + encodeURIComponent(handle) + '.js').catch(function (err) {
        delete productCache[handle];
        return err && err.status === 404 ? { missing: true } : null;
      });
    }
    return productCache[handle];
  }

  var renderToken = 0;
  function wlRender() {
    var list = document.querySelector('[data-wish-list]');
    var empty = document.querySelector('[data-wish-empty]');
    if (!list) return;
    var a = wlGet();
    if (empty) empty.hidden = a.length > 0;
    if (!a.length) { list.innerHTML = ''; return; }
    var token = ++renderToken;
    if (!list.children.length) list.innerHTML = '<li class="wish__loading">' + esc(T.loading) + '</li>';
    Promise.all(a.map(fetchProduct)).then(function (items) {
      if (token !== renderToken) return;
      var missing = [];
      var html = items.map(function (p, i) {
        if (!p) return '';
        if (p.missing) { missing.push(a[i]); return ''; }
        var variants = p.variants || [];
        var v = variants.filter(function (x) { return x.available; })[0] || variants[0] || {};
        var url = root + 'products/' + p.handle;
        var img = p.featured_image ? sized(p.featured_image, 160) : '';
        var minQty = (v.quantity_rule && v.quantity_rule.min) || 1;
        var action;
        if (!p.available) {
          action = '<span class="stock stock--out">' + esc(T.soldOut) + '</span>';
        } else if (variants.length > 1) {
          action = '<a class="btn-cart" href="' + esc(url) + '"><span>' + esc(T.chooseOptions) + '</span></a>';
        } else {
          action = '<form method="post" action="' + esc(root + 'cart/add') + '" data-rnw-add>' +
            '<input type="hidden" name="id" value="' + esc(v.id) + '">' +
            '<input type="hidden" name="quantity" value="' + esc(minQty) + '">' +
            '<button type="submit" class="btn-cart"><span>' + esc(T.addToCart) + '</span></button></form>';
        }
        return '<li class="wish__item">' +
          '<a class="wish__img" href="' + esc(url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</a>' +
          '<div class="wish__info">' +
            '<a class="wish__name" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
            '<span class="wish__price">' + esc(money(v.price != null ? v.price : p.price)) + ' <small>' + esc(T.taxIncluded) + '</small></span>' +
            '<div class="wish__actions">' + action +
              '<button type="button" class="wish__remove" data-wish-remove="' + esc(p.handle) + '">' + esc(T.wishRemoveShort) + '</button>' +
            '</div>' +
          '</div>' +
        '</li>';
      }).join('');
      list.innerHTML = html;
      if (missing.length) {
        wlSet(wlGet().filter(function (h) { return missing.indexOf(h) === -1; }));
      }
    });
  }

  var lastFocus = null;
  function wlOpen() {
    var d = document.querySelector('[data-wish-drawer]');
    if (!d) return;
    lastFocus = document.activeElement;
    document.body.classList.remove('drawer-open');
    document.body.classList.add('wish-open');
    d.setAttribute('aria-hidden', 'false');
    wlRender();
    var c = d.querySelector('[data-wish-close]');
    if (c) setTimeout(function () { c.focus(); }, 50);
  }
  function wlClose() {
    if (!document.body.classList.contains('wish-open')) return;
    var d = document.querySelector('[data-wish-drawer]');
    document.body.classList.remove('wish-open');
    if (d) d.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  window.addEventListener('storage', function (e) { if (e.key === WKEY) wlSync(); });
  // cards added after load (cart recommendations) need their heart state
  document.addEventListener('rnw:cards-added', wlSync);

  // ---------- predictive search ----------
  // Shopify's predictive search API rejects some storefront languages (e.g. Japanese:
  // "Unsupported buyer locale"). There we read the normal search through a JSON view
  // (templates/search.rnw-suggest.liquid) and match category names locally.
  var useApi = C.suggestApi !== false;
  function suggestUrl(q, types, limit) {
    return (C.suggestUrl || root + 'search/suggest') + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=' + types + '&resources[limit]=' + limit + '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last';
  }
  function viewUrl(q, type) {
    return (C.searchUrl || root + 'search') + '?q=' + encodeURIComponent(q) + '&type=' + type +
      '&options%5Bprefix%5D=last&view=rnw-suggest';
  }
  function viewResults(q, type, signal) {
    return fetch(viewUrl(q, type), { credentials: 'same-origin', signal: signal })
      .then(function (r) { return r.text(); })
      .then(function (t) { try { return JSON.parse(t).results || []; } catch (err) { return []; } });
  }
  function matchCollections(q) {
    var ql = q.toLowerCase();
    return (C.cols || []).filter(function (c) { return c.t && c.t.toLowerCase().indexOf(ql) > -1; })
      .slice(0, 6).map(function (c) { return { title: c.t, url: c.u }; });
  }
  // Resolves to { resources: { results: { products, collections, pages, articles } } } either way.
  function getSuggestions(q, types, signal) {
    var wantProducts = types.indexOf('product') > -1;
    if (useApi) {
      return fetch(suggestUrl(q, types, 6), { headers: JSON_HEADERS, credentials: 'same-origin', signal: signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.resources) return data;
          useApi = false; // e.g. 417 Unsupported buyer locale
          return getSuggestions(q, types, signal);
        });
    }
    return Promise.all([
      wantProducts ? viewResults(q, 'product', signal) : Promise.resolve([]),
      viewResults(q, 'article,page', signal)
    ]).then(function (res) {
      return { resources: { results: {
        products: res[0].filter(function (x) { return x.type === 'product'; }),
        collections: wantProducts ? matchCollections(q) : [],
        pages: res[1].filter(function (x) { return x.type === 'page' || x.type === 'article'; }),
        articles: []
      } } };
    });
  }
  function renderPredict(data, q) {
    var r = (data && data.resources && data.resources.results) || {};
    var prods = r.products || [];
    var cols = r.collections || [];
    var pages = (r.pages || []).concat(r.articles || []);
    var h = '';
    if (cols.length) {
      h += '<div class="psearch__group"><div class="psearch__label">' + esc(T.collections) + '</div><div class="psearch__chips">' +
        cols.slice(0, 6).map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') +
        '</div></div>';
    }
    if (prods.length) {
      h += '<div class="psearch__group"><div class="psearch__label">' + esc(T.products) + '</div><ul class="psearch__list">' +
        prods.slice(0, 6).map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image;
          var price = p.price_cents != null ? money(p.price_cents)
            : (p.price != null && p.price !== '' ? money(Math.round(parseFloat(p.price) * 100)) : '');
          return '<li><a class="psearch__item" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(sized(img, 96)) + '" alt="" width="44" height="44" loading="lazy">' : '<span class="psearch__ph"></span>') +
            '<span class="psearch__name">' + esc(p.title) + '</span>' +
            '<span class="psearch__price">' + esc(price) + (p.available === false ? '<small>' + esc(T.soldOut) + '</small>' : '') + '</span>' +
            '</a></li>';
        }).join('') + '</ul></div>';
    } else {
      h += '<p class="psearch__empty">' + esc(T.noResults) + '</p>';
    }
    if (pages.length) {
      h += '<div class="psearch__group"><div class="psearch__label">' + esc(T.pages) + '</div><ul class="psearch__links">' +
        pages.slice(0, 4).map(function (p) { return '<li><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></li>'; }).join('') +
        '</ul></div>';
    }
    var all = (C.searchUrl || root + 'search') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    h += '<a class="psearch__all" href="' + esc(all) + '">' + esc((T.viewAll || '').replace('[terms]', q)) + '</a>';
    return h;
  }
  function initPredict(wrap) {
    var input = wrap.querySelector('[data-psearch-input]');
    var panel = wrap.querySelector('[data-psearch-panel]');
    if (!input || !panel || !window.fetch) return;
    var timer, ctrl, lastQ = '';
    var pid = 'psearch-' + Math.random().toString(36).slice(2, 8);
    panel.id = pid;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', pid);

    function open() { panel.hidden = false; wrap.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
    function close() { panel.hidden = true; wrap.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); }
    wrap._psClose = close;

    function run(q) {
      if (q === lastQ && panel.innerHTML) { open(); return; }
      lastQ = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      getSuggestions(q, 'product,collection,page,article', ctrl ? ctrl.signal : undefined)
        .then(function (data) {
          if (q !== input.value.trim()) return;
          panel.innerHTML = renderPredict(data, q);
          open();
        })
        .catch(function () {});
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (!q) { close(); return; }
      timer = setTimeout(function () { run(q); }, 220);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim() && panel.innerHTML && input.value.trim() === lastQ) open();
    });
    wrap.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      var links = [].slice.call(panel.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && links.length) {
        e.preventDefault();
        (links[i + 1] || links[0]).focus();
      } else if (e.key === 'ArrowUp' && links.length) {
        e.preventDefault();
        if (i <= 0) { input.focus(); } else { links[i - 1].focus(); }
      } else if (e.key === 'Escape') {
        close();
        input.focus();
      }
    });
  }

  // ---------- search results page: matching pages & articles ----------
  function initSearchExtra() {
    var box = document.querySelector('[data-search-extra]');
    var q = box && box.getAttribute('data-terms');
    if (!q || !window.fetch) return;
    getSuggestions(q, 'page,article').then(function (data) {
      var r = (data && data.resources && data.resources.results) || {};
      var items = (r.pages || []).concat(r.articles || []);
      if (!items.length) return;
      box.querySelector('[data-search-extra-list]').innerHTML = items.slice(0, 8).map(function (p) {
        return '<li><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></li>';
      }).join('');
      box.hidden = false;
    }).catch(function () {});
  }

  // ---------- copy link ----------
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (err) {}
    document.body.removeChild(ta);
  }
  function copyLink(btn) {
    var url = btn.getAttribute('data-copy-url') || location.href;
    if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
    var done = function () {
      btn.textContent = btn.getAttribute('data-copied') || 'OK';
      btn.classList.add('is-done');
      setTimeout(function () { btn.textContent = btn.getAttribute('data-label'); btn.classList.remove('is-done'); }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { fallbackCopy(url); done(); });
    } else {
      fallbackCopy(url);
      done();
    }
  }

  // ---------- delegated events ----------
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-toast-close]')) { hideToast(); return; }
    var w = t.closest('[data-wish]');
    if (w) { e.preventDefault(); wlToggle(w.getAttribute('data-wish')); return; }
    if (t.closest('[data-wish-open]')) { e.preventDefault(); wlOpen(); return; }
    if (t.closest('[data-wish-close]')) { wlClose(); return; }
    var rm = t.closest('[data-wish-remove]');
    if (rm) {
      var h = rm.getAttribute('data-wish-remove');
      wlSet(wlGet().filter(function (x) { return x !== h; }));
      return;
    }
    var cp = t.closest('[data-copy-url]');
    if (cp) { e.preventDefault(); copyLink(cp); return; }
    // close predictive panels when clicking elsewhere
    document.querySelectorAll('[data-psearch]').forEach(function (wrap) {
      if (!wrap.contains(t) && wrap._psClose) wrap._psClose();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { wlClose(); hideToast(); }
  });

  // ---------- init ----------
  wlSync();
  document.querySelectorAll('[data-psearch]').forEach(initPredict);
  initSearchExtra();
})();
